/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as SyncDefs from './defs.defs'

const $nsid = 'com.atproto.sync.getHostStatus'

type $nsid = typeof $nsid

export { $nsid }

export const $params = /*#__PURE__*/ l.params({
  hostname: /*#__PURE__*/ l.string(),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  seq: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
  status: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.ref<SyncDefs.HostStatus>(
      (() => SyncDefs.hostStatus) as any,
    ),
  ),
  hostname: /*#__PURE__*/ l.string(),
  accountCount: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.integer()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Returns information about a specified upstream host, as consumed by the server. Implemented by relays. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output, ['HostNotFound'])

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
